/*
 * Clim & Chill — Consentement cookies (RGPD / CNIL), maison, sans dépendance.
 * Reproduit lib/consent.ts + CookieConsent.tsx du site Next.js.
 * - Cookie `cc_consent` (JSON) fait foi, miroir localStorage, durée 6 mois.
 * - Opt-in réel : rien n'est pré-coché ; « Tout accepter » et « Tout refuser » identiques.
 * - Réouvrable via l'événement `open-cookie-settings` et tout bouton [data-cc-cookie-settings].
 * - Pilote Google Consent Mode v2 (dataLayer) et purge les cookies Google au retrait.
 */
(function () {
  "use strict";

  var COOKIE = "cc_consent";
  var STORAGE_KEY = "cc_consent";
  var MAX_AGE = 60 * 60 * 24 * 182; // 6 mois
  var OPEN_EVENT = "open-cookie-settings";
  var UPDATED_EVENT = "cc-consent-updated";

  function readConsent() {
    if (typeof document === "undefined") return null;
    var rows = document.cookie.split("; ");
    var match = null;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].indexOf(COOKIE + "=") === 0) { match = rows[i]; break; }
    }
    if (!match) return null;
    try {
      var raw = decodeURIComponent(match.slice(COOKIE.length + 1));
      var parsed = JSON.parse(raw);
      return {
        essential: true,
        analytics: Boolean(parsed.analytics),
        marketing: Boolean(parsed.marketing),
        ts: typeof parsed.ts === "number" ? parsed.ts : Date.now()
      };
    } catch (e) {
      return null;
    }
  }

  function deleteCookie(name) {
    var host = typeof location !== "undefined" ? location.hostname : "";
    var domains = ["", host, host ? "." + host : ""];
    for (var i = 0; i < domains.length; i++) {
      var domainPart = domains[i] ? "; domain=" + domains[i] : "";
      document.cookie = name + "=; Max-Age=0; path=/" + domainPart;
    }
  }

  function clearGoogleCookies(input) {
    var names = {};
    if (!input.analytics) {
      names["_ga"] = 1; names["_gid"] = 1; names["_gat"] = 1;
      var pairs = document.cookie.split("; ");
      for (var i = 0; i < pairs.length; i++) {
        var n = pairs[i].split("=")[0];
        if (n && n.indexOf("_ga_") === 0) names[n] = 1;
      }
    }
    if (!input.marketing) names["_gcl_au"] = 1;
    for (var key in names) { if (names.hasOwnProperty(key)) deleteCookie(key); }
  }

  function toGtagConsent(state) {
    var a = state.analytics ? "granted" : "denied";
    var m = state.marketing ? "granted" : "denied";
    return {
      analytics_storage: a,
      ad_storage: m,
      ad_user_data: m,
      ad_personalization: m
    };
  }

  function applyConsentToGtag(state) {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    var gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag = gtag;
    gtag("consent", "update", toGtagConsent(state));
  }

  // Propage le consentement à l'API Customer Privacy de Shopify (pixels, audiences,
  // marketing gérés par Shopify). Nécessaire car on a retiré la bannière native Shopify :
  // sans ceci, le tracking Shopify resterait éteint même après « Tout accepter ».
  function applyConsentToShopify(state) {
    if (typeof window === "undefined" || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
      if (error) return;
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: Boolean(state.analytics),
          marketing: Boolean(state.marketing),
          preferences: Boolean(state.analytics),
          sale_of_data: Boolean(state.marketing)
        }, function () {});
      } catch (e) {}
    });
  }

  function writeConsent(input) {
    var previous = readConsent();
    var state = {
      essential: true,
      analytics: input.analytics,
      marketing: input.marketing,
      ts: Date.now()
    };
    var analyticsWithdrawn = Boolean(previous && previous.analytics) && !input.analytics;
    var marketingWithdrawn = Boolean(previous && previous.marketing) && !input.marketing;
    if (analyticsWithdrawn || marketingWithdrawn) {
      clearGoogleCookies({ analytics: input.analytics, marketing: input.marketing });
    }
    var value = encodeURIComponent(JSON.stringify(state));
    var secure = (typeof location !== "undefined" && location.protocol === "https:") ? "; Secure" : "";
    document.cookie = COOKIE + "=" + value + "; path=/; max-age=" + MAX_AGE + "; SameSite=Lax" + secure;
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    applyConsentToGtag(state);
    applyConsentToShopify(state);
    window.dispatchEvent(new CustomEvent(UPDATED_EVENT, { detail: state }));
    return state;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.getElementById("cc-consent");
    if (!root) return;

    var panel = root.querySelector("[data-cc-panel]");
    var analyticsInput = root.querySelector("#cc-consent-analytics");
    var marketingInput = root.querySelector("#cc-consent-marketing");
    var btnPersonnaliser = root.querySelector("[data-cc-personnaliser]");
    var btnSave = root.querySelector("[data-cc-save]");

    function show() { root.hidden = false; }
    function hide() { root.hidden = true; }

    function setCustomizing(on) {
      if (panel) panel.hidden = !on;
      if (btnPersonnaliser) btnPersonnaliser.hidden = on;
      if (btnSave) btnSave.hidden = !on;
    }

    function save(analytics, marketing) {
      writeConsent({ analytics: analytics, marketing: marketing });
      setCustomizing(false);
      hide();
    }

    function openSettings() {
      var current = readConsent();
      if (analyticsInput) analyticsInput.checked = Boolean(current && current.analytics);
      if (marketingInput) marketingInput.checked = Boolean(current && current.marketing);
      setCustomizing(true);
      show();
      try { root.focus(); } catch (e) {}
    }

    root.querySelector("[data-cc-accept]").addEventListener("click", function () { save(true, true); });
    root.querySelector("[data-cc-reject]").addEventListener("click", function () { save(false, false); });
    if (btnPersonnaliser) btnPersonnaliser.addEventListener("click", function () { setCustomizing(true); try { root.focus(); } catch (e) {} });
    if (btnSave) btnSave.addEventListener("click", function () {
      save(Boolean(analyticsInput && analyticsInput.checked), Boolean(marketingInput && marketingInput.checked));
    });

    // Réouverture depuis le footer / la page cookies / n'importe où.
    window.addEventListener(OPEN_EVENT, openSettings);
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest ? e.target.closest("[data-cc-cookie-settings]") : null;
      if (trigger) { e.preventDefault(); openSettings(); }
    });

    // Affichage initial : uniquement si aucun choix stocké.
    setCustomizing(false);
    if (!readConsent()) show();
    else { applyConsentToGtag(readConsent()); applyConsentToShopify(readConsent()); }
  });

  // Expose l'ouverture programmatique.
  window.openCookieSettings = function () {
    if (typeof window !== "undefined") window.dispatchEvent(new Event(OPEN_EVENT));
  };
})();
